import { Box, Step, StepConnector, StepLabel, Stepper, styled } from '@mui/material'
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react'

const StylizedConnector = styled(StepConnector)(({ theme }) => ({
    '& .MuiStepConnector-line': {
        borderColor: '#BDBDBD',
        borderTopWidth: '2px',
    },
    '&.Mui-active .MuiStepConnector-line': {
        borderColor: '#FF9F0D',
    },
    '&.Mui-completed .MuiStepConnector-line': {
        borderColor: '#FF9F0D',
    },
    position: 'absolute',
    top: '10',
    transform: 'translateY(100%)',
    left: 'calc(-50% + 11px)',
    right: 'calc(50% + 10px)',
    zIndex: '-1',
}));

const StylizedIcon = (props) => {
    const { active, completed } = props;

    const iconsStyled = {
        fontSize: '30px',
    }

    const icons = {
        1: <CheckCircleIcon sx={iconsStyled}/>,
        2: <CheckCircleOutlineOutlinedIcon sx={iconsStyled}/>,
        3: <RadioButtonCheckedOutlinedIcon sx={iconsStyled}/>,
    }

    return (
        <Box
            sx={{
                color: completed ? '#FF9F0D' : active ? '#FF9F0D' : '#BDBDBD',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '.MuiStepIcon-root': {
                    color: 'inherit',
                    width: 30,
                    height: 30,
                }
            }}
        >
            {completed ? <CheckCircleIcon sx={{ color: '#FF9F0D', fontSize: '30px' }} /> : icons[String(props.icon)]}
        </Box>
    );
}

const CustomizedSteppers = ({activeStep = 1}) => {
    const steps = ['Escolha de plano', 'Dados', 'Pagamento']
  
    return (
        <Box 
            sx={{ 
                width: '75%',
                mx: 'auto',
                '@media (max-width: 400px)': {
                    width: '100%',
                }
            }}
        >
            <Stepper activeStep={activeStep} alternativeLabel connector={<StylizedConnector />} >
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={StylizedIcon}>
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    )
}

export default CustomizedSteppers
